export const STATUS_MAP: Record<string, string> = {
  '0': 'Chưa ghi sổ',
  '3': 'Chờ duyệt',
  '5': 'Đã ghi sổ',
  '9': 'Hủy'
};

export const E_INVOICE_STATUS_MAP: Record<string, string> = {
  '0': 'Không sử dụng',
  '1': 'Chờ phát hành',
  '2': 'Chờ ký',
  '3': 'Xác thực',
  '4': 'Điều chỉnh',
  '5': 'Thay thế',
  '7': 'Thuế từ chối',
  '8': 'Chờ hủy',
  '9': 'Hủy',
  '10': 'Thuế không đồng ý'
};

export const PHIEU_XUAT_TRA_LAI_EXPORT_TITLE = 'PHIẾU XUẤT TRẢ LẠI NHÀ CUNG CẤP';
export const PHIEU_XUAT_TRA_LAI_FILE_NAME = 'Phiếu xuất trả lại nhà cung cấp';
export const PHIEU_XUAT_TRA_LAI_SHEET_NAME = 'PhieuXuatTraLai';
